import { motion } from 'framer-motion';
import { KeyIcon } from './EscapeIcons';
import { openBookingModal } from './BookingModal';
import { useLanguage } from '../context/LanguageContext';

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[55vh] sm:min-h-[60vh] flex flex-col items-center justify-center overflow-hidden bg-black pb-4 sm:pb-8"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-24 sm:pt-36">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="font-heading text-[11px] sm:text-xl lg:text-2xl tracking-[0.15em] sm:tracking-[0.3em] text-brand uppercase mb-2 sm:mb-6 px-8 sm:px-0"
        >
          {t('heroTagline')}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="font-heading text-4xl sm:text-8xl lg:text-[11rem] leading-none tracking-normal text-white uppercase neon-text-glow"
        >
          {t('canYou')} <span className="text-brand">{t('escape')}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="font-sans text-sm sm:text-xl lg:text-2xl text-neutral-300 max-w-3xl mx-auto mt-4 sm:mt-8 leading-relaxed font-medium"
        >
          {t('heroDescription')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
          className="mt-6 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
        >
          <button
            onClick={openBookingModal}
            data-testid="hero-book-now-btn"
            className="font-heading tracking-widest uppercase bg-brand text-white px-8 sm:px-12 py-3 sm:py-5 rounded-full hover:bg-brand-hover transition-colors text-base sm:text-xl shadow-[0_0_20px_rgba(227,37,16,0.3)] hover:shadow-[0_0_40px_rgba(227,37,16,0.5)]"
          >
            {t('bookNow')}
          </button>
          <a
            href="#rooms"
            data-testid="hero-explore-rooms-btn"
            className="font-heading tracking-widest uppercase border-2 border-white/30 text-white px-8 sm:px-12 py-3 sm:py-5 rounded-full hover:border-brand hover:text-brand transition-colors text-base sm:text-xl"
          >
            {t('exploreRooms')}
          </a>
        </motion.div>
      </div>

      <motion.a
        href="#rooms"
        data-testid="scroll-key-indicator"
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
        className="absolute bottom-3 sm:bottom-6 left-1/2 -translate-x-1/2 text-white/50 hover:text-brand transition-colors cursor-pointer hidden sm:block"
      >
        <KeyIcon size={30} className="rotate-180" />
      </motion.a>
    </section>
  );
}
